import styled from 'styled-components';

export const ProductInfo = styled.label<{ checked?: boolean }>`
  display: flex;
  padding: 24px;
  border-radius: 24px;
  background: #18191c;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  outline: ${({ checked }) => (checked ? '2px solid #95d1f1' : 'none')};
  outline-offset: -2px;
  position: relative;
  overflow: hidden;
  z-index: 0;
  cursor: pointer;
`;

export const TopRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
